import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo } from 'react';
import { Popper as ReactPopper } from 'react-popper';
export { placements } from '@popperjs/core';
// Export types from PopperJS / React Popper

var constantModifiers = [{
  name: 'flip',
  options: {
    flipVariations: false,
    padding: 5,
    boundary: 'clippingParents',
    rootBoundary: 'viewport'
  }
}, {
  name: 'preventOverflow',
  options: {
    padding: 5,
    rootBoundary: 'document'
  }
}];
function defaultChildrenFn() {
  return null;
}
var defaultOffset = [0, 8];
export function Popper(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? defaultChildrenFn : _ref$children,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? defaultOffset : _ref$offset,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
    _ref$referenceElement = _ref.referenceElement,
    referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement,
    modifiers = _ref.modifiers,
    _ref$strategy = _ref.strategy,
    strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy;
  var _offset = _slicedToArray(offset, 2),
    offsetX = _offset[0],
    offsetY = _offset[1];
  // Merge a new offset modifier only if new offset values passed in
  var internalModifiers = useMemo(function () {
    var offsetModifier = {
      name: 'offset',
      options: {
        offset: [offsetX, offsetY]
      }
    };
    return [].concat(constantModifiers, [offsetModifier]);
  }, [offsetX, offsetY]);

  // Merge custom props and memoize
  var mergedModifiers = useMemo(function () {
    if (modifiers == null) {
      return internalModifiers;
    }
    return [].concat(_toConsumableArray(internalModifiers), _toConsumableArray(modifiers));
  }, [internalModifiers, modifiers]);
  return /*#__PURE__*/React.createElement(ReactPopper, {
    modifiers: mergedModifiers,
    placement: placement,
    strategy: strategy,
    referenceElement: referenceElement
  }, children);
}